/**
 * /draft/:id/board - Standalone read-only draft board.
 * Opens in a new tab; connected to live draft via WebSocket.
 * Team columns ordered by nomination_order (Section 3B).
 */
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { authHeaders } from "../contexts/AuthContext";
import { DraftProvider } from "../contexts/DraftContext";
import StandaloneDraftBoard from "../components/draft/StandaloneDraftBoard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DraftBoardPage() {
  const { id: leagueId } = useParams();
  const nav = useNavigate();
  const [league, setLeague]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/leagues/${leagueId}`, { headers: authHeaders() })
      .then(r => {
        setLeague(r.data);
        // [BOARD MIRROR] LOBBY is allowed now: the board opens from the
        // lobby and scaffolds the empty grid before the draft starts.
        if (r.data.status === "SETUP") {
          nav("/dashboard");
        }
      })
      .catch(() => nav("/dashboard"))
      .finally(() => setLoading(false));
  }, [leagueId]);

  if (loading) return (
    <div className="min-h-screen bg-[#111111] flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-[#FF6B00] border-t-transparent rounded-full animate-spin" />
    </div>
  );

  return (
    <DraftProvider leagueId={leagueId} silent>
      <StandaloneDraftBoard leagueId={leagueId} league={league} />
    </DraftProvider>
  );
}
